import React from 'react';
import _ from 'lodash';
import Select2 from 'react-select2-wrapper';
import 'react-select2-wrapper/css/select2.css';
import '../../assets/css/components/render-select.css';

class AssignmentSelect extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedAssignees: []
    }
  }
  getLabel = ()=> (this.props.label && <label onClick={e=>e.preventDefault()} htmlFor={this.props.input.id || this.props.input.name}>{this.props.label}</label>)

  updateSelectedAssignees = e => {
    const selected = Array.from(e.target.options)
      .filter(option => option.selected)
      .map(option => option.value);

    if (!_.isEqual(this.state.selectedAssignees, selected)){
      this.props.onAssigneeChange() // defined in index, sets the formChanged state boolean
      this.props.updateValue(this.props.input.name,selected)
      this.setState({selectedAssignees: selected})
    }
  }

  //If the field value according to react-form is different than the input (should only be in the case of default assignees being set),
  //set the selected assignees correctly
  checkFieldValue = (fieldValue) => {
    if(!_.isEqual(this.state.selectedAssignees, this.props.fieldValue)){
      this.setState({selectedAssignees: fieldValue})
    }
  }

  //This is to check on component mount (in the case that user is making an assignment change) that
  //the selected assignee is the same as default assignee.  
  componentDidMount(){
    this.checkFieldValue(this.props.fieldValue)
  }

  render(){
    const { defaultValue, multiple, data, placeholder, hidden, input, label, wrapperClass, type, isNew, fieldValue } = this.props

    return(
      <div className={`${type} ${wrapperClass} input select-form-group form-group form-group-default`}>
        {this.getLabel()}
        <Select2  multiple={multiple} data={data} name={input.name} {...input}  className={`form-control no-box-shadow`} id={input.name} value={this.state.selectedAssignees} onChange={this.updateSelectedAssignees}/>
      </div>
    )
  }
}

export default AssignmentSelect;
